import Enum from "./Enum";
import OneOnOneTeamRoleType from "./OneOnOneTeamRoleType";

export default Enum.create( {
	LEAD: "LEAD",
	MEMBER: "MEMBER",
	// these roles are really 1:1 team roles
	// @see OneOnOneTeamRoleType
	// leaving them here for legacy purposes
	MANAGER: OneOnOneTeamRoleType.MANAGER,
	REPORT: OneOnOneTeamRoleType.REPORT,
	PEER: OneOnOneTeamRoleType.PEER,
} );
